

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CityLink } from '../models/city-link.interface';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SeoService {


    seoUrl: string = environment.chatBotUrl ;

    constructor(private _httpClient: HttpClient) { }


    



    getSeoContentByUrl(url: string): any {
       return this._httpClient.get(`${this.seoUrl}/api/v1/seo/seo-generator/url/${url}`)        
    }
    getCityLinks(cityId: string, lang: string): Observable<CityLink[]> {
       return this._httpClient.get<CityLink[]>(`${this.seoUrl}/api/v1/seo/seo-generator/city/${cityId}?lang=${lang}`);
    }
    findByWeight(weight: number, lang: string,cityNumber=1): Observable<{url: string, text: string}[]> {
       return this._httpClient.get<{url: string, text: string}[]>(`${this.seoUrl}/api/v1/seo/seo-generator/weights/${weight}?lang=${lang}&&city=${cityNumber}`);        
    }
}